module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "request-subjects text-dark"
  }, [_c('div', {
    staticClass: "request-subjects__header"
  }, [_c('div', {
    staticClass: "request-subjects__header__left"
  }, [_c('h1', [_vm._v("Reduktioner")]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--large do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isRefreshingOrLoadingSubjects
    },
    on: {
      "click": _vm.refreshReductions
    }
  }, [_vm._v("\n      Opdater reduktioner\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "request-subjects-grid"
  }, [_c('div', {
    staticClass: "doTable"
  }, [_c('div', {
    staticClass: "subject-dist__header"
  }, [_c('div', {
    staticClass: "subject-dist__header__left"
  }, [_c('Tabslist', {
    attrs: {
      "tabs": ['Aktiviteter', 'Fag'],
      "isLarge": true,
      "selected": _vm.selectedTab
    },
    on: {
      "select": _vm.onSelectTab
    }
  }), _vm._v(" "), (_vm.selectedTab === 'Fag') ? _c('div', {
    staticClass: "do-search"
  }, [_c('input', {
    staticClass: "do-input",
    attrs: {
      "type": "search",
      "placeholder": "Søg på fag"
    },
    on: {
      "input": _vm.debounceSearch
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'Fag') ? _c('DoFiltersFilter', {
    attrs: {
      "title": 'Klasser',
      "tags": _vm.klassTags,
      "selectedTags": _vm.selectedKlassFilters
    },
    on: {
      "select": _vm.toggleKlassTag,
      "clear": function($event) {
        _vm.selectedKlassFilters = []
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isRefreshingOrLoadingSubjects) ? _c('Loader', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "is-extra-small": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectedTab === 'Aktiviteter') ? _c('BulkCreateSubjects', {
    attrs: {
      "isActivities": true,
      "prop-is-subject-modal": _vm.isCreateActivityModal
    },
    on: {
      "closeSubjectModal": function($event) {
        return _vm.setIsCreateActivityModal(false)
      }
    }
  }) : _c('ul', {
    staticClass: "doTable__items"
  }, _vm._l((_vm.filteredKlassCals), function(klassCal, idx) {
    return _c('li', {
      key: klassCal.id,
      staticClass: "doTable__klass"
    }, [_c('div', {
      staticClass: "doTable__klass__header"
    }, [_c('div', [_vm._v(_vm._s(klassCal.name))]), _vm._v(" "), _c('p', [_c('label', [_vm._v("FØR")]), _vm._v(" " + _vm._s(klassCal.vSubjectsSumRaw) + " "), _c('label', [_vm._v("|")]), _vm._v(" "), _c('label', [_vm._v("EFTER")]), _vm._v(" " + _vm._s(klassCal.vSubjectsSum))])]), _vm._v(" "), _c('ul', {
      staticClass: "grade-subjects"
    }, _vm._l((klassCal.vSubjects), function(subject) {
      return _c('li', {
        key: subject.id,
        staticClass: "grade-subjects_subject",
        style: ({
          'background': subject.color
        }),
        on: {
          "click": function($event) {
            return _vm.setEditSubject(subject)
          }
        }
      }, [_vm._v("\n              " + _vm._s(subject.name) + " (" + _vm._s(subject.vHours) + ")\n            ")])
    }), 0)])
  }), 0)], 1)]), _vm._v(" "), (_vm.editSubject) ? _c('SubjectForm', {
    attrs: {
      "showModal": _vm.editSubject,
      "editSubject": _vm.editSubject,
      "propTab": 'reductions',
      "isActivities": true
    },
    on: {
      "close": _vm.closeEditSubjectModal,
      "deleteSubject": _vm.deleteSubject,
      "updateSubject": _vm.updateSubject
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d5532c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reductions/Reductions.vue
// module id = 1700
// module chunks = 1